// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 526) return "static/chunks/526-8a61f473b40b3c40.js";
	if (chunkId === 964) return "static/chunks/964-82815f5ebda8a0b5.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"87a6db885125b558","227":"9a1005a5d42e738d","435":"2a838853e7f751ff","574":"0501f8171e960c10","608":"0df5227fb617b44d","621":"5456bc9fecd505f9","777":"dcdf79c5cdc62826","871":"f94210cb063b730d","908":"25ae35b5d4e4eee3"}[chunkId] + ".js";
};